/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Admin_HintInputs */



/**
* | output |
* | --- |
* | "Nothing is sent now. The administrator is emailed an invitation when the organization goes live." |
*
* @param {Partner_Add_Contract_Admin_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_admin_hint = /** @type {((inputs?: Partner_Add_Contract_Admin_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Admin_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt wird nichts versendet. Die Administration erhält eine Einladung per E-Mail, sobald die Organisation aktiv wird.")
	return /** @type {LocalizedString} */ ("Nothing is sent now. The administrator is emailed an invitation when the organization goes live.")
});